import { SubscribeProductType } from '@/libs/type/interfaces/subscription.interface';

export const TOKEN_REFRESH_URL = '/certificate/apis/unrestricted/token/reissue';
export const SEND_OPT_URL = '/user/apis/unrestricted/send-otp';
export const SEND_OPT_URL_SIGN_UP = '/api/v1/otp/send';
export const USER_LOGIN_URL = '/user/apis/sign-in';
export const APP_STORE_BY_USER = '/api/v1/app-user-store/list';
export const MATCH_USER_APP_STORE = '/api/v1/app-user-store/match';
export const LOGIN_USER_INFO = '/api/v1/app-users/me';
export const STORE_SWITCH_URL = '/user/apis/store/switch';
export const SNS_SIGN_IN_URL = '/user/apis/sns/sign-in';
export const UPDATE_USER_PHONE = '/user/apis/user/update/phone';

export const REVIEWS = '/post/apis/unrestricted/reviews';
export const STORE = '/user/apis/unrestricted/store';

export const DEMO_ALARM = '/notification/apis/v2/review-boost/unrestricted/demo-message';
export const CONTACT = '/user/apis/unrestricted/consulting';

export const ALARM_TALK_HISTORY = (storeId: string) => `/notification/apis/review-boost/messages/${storeId}/pagination`;
export const ALARM_TALK_HISTORY_EXCEL = (storeId: string) => `/notification/apis/review-boost/messages/${storeId}/excel`;
export const REVIEW_BOOST_MESSAGE_TEMPLATE = (storeId: number) => `/notification/apis/v2/review-boost/stores/${storeId}/message-template`;
export const STORE_AUTHORITY = (storeId: string) => `/user/apis/user-authority/store/${storeId}`;
export const PRESENT_LIST = (storeId: string) => `/product/apis/review-boost/present/list/${storeId}`;
export const REVIEW_CHANNEL_LIST = '/product/apis/review-boost/review/channel';
export const SEND_PRESENT = '/product/apis/review-boost/send/present';
export const RECEIPT_PRESENT_HISTORY = (receiptId: number, messageId: string) => `/product/apis/review-boost/receipt/${receiptId}/message/${messageId}/sent-present`;
export const CHECK_PRODUCT_IS_SUBSCRIBED = (productType: SubscribeProductType) => `/product/apis/product/subscriptions/${productType}/is-subscribed`;
export const SUBSCRIBED_STORES = (productType: SubscribeProductType) => `/product/apis/product/subscriptions/${productType}/subscribed-stores`;
export const REVIEW_BOOST = (messageId: string) => `/product/apis/review-boost/unrestricted/inquiry?message_id=${messageId}`;
export const REVIEW_BOOST_FINAL_REVIEW = (messageId: string) => `/product/apis/review-boost/unrestricted/inquiry/${encodeURIComponent(messageId)}/final-review`;
export const REVIEW_BOOST_PLATFORM_CLICK = (messageId: string) => `/product/apis/review-boost/unrestricted/inquiry/${messageId}/platform-click`;

//Legacy
// ⚠️ 운영 게이트웨이 절대주소 금지(2026-08-14). 아래 두 상수가 `gateway.medilawyer.co.kr` 로
//    박혀 있어서 개발계·로컬 빌드까지 전부 **운영**을 때렸다.
//    호출부가 axios 가 아니라 raw fetch 라 상대경로는 프론트 자기 origin 으로 가버린다 —
//    그래서 authn.ts 선례대로 NEXT_PUBLIC_BASE_URL(빌드별 게이트웨이)을 접두한다.
//    운영=운영 GW · 신 개발계=gateway.next.dev.revieworks.com · 구 개발계=dev GW.
//
// 다만 그 값이 **없을 때**는 `undefined/api/v1/...` 이라는 상대경로가 되어
// 중첩 화면에서 `/stores/1/undefined/api/v1/...` 로 나간다. 없으면 루트 기준으로 떨어뜨린다.
const API_BASE_URL = process.env.NEXT_PUBLIC_BASE_URL ?? '';

export const CREATE_REVIEW = (organizationId: string, teamId: string, messageId: string) =>
  `${API_BASE_URL}/api/v1/boost1/organizations/${organizationId}/teams/${teamId}/messages/${messageId}/posts`;
export const DOWNLOAD_RECEIPT = (messageId: string) => `${API_BASE_URL}/crawling/apis/file/unrestricted/review-boost/receipt/download?messageId=${encodeURIComponent(messageId)}`;
